// could be switched based on environment, localStorage key presence etc.
const tested = true;
export const tidv = (...id: string[]) => id.join('-');
export const tid = (...id: string[]) => (tested ? {'data-testid': tidv(...id)} : {});
